module.exports = __webpack_public_path__ + "img/PowderHorn_TH.0f22eba4.png";